"use strict";
/**
* Copyright: Microsoft 2016
*/
Object.defineProperty(exports, "__esModule", { value: true });
var InternalLogger = /** @class */ (function () {
    function InternalLogger() {
        var _this = this;
        this.init = function (settings) {
            _this.logger = settings.logger;
        };
        this.error = function (msg) {
            if (_this.logger) {
                _this.logger.error(msg);
            }
        };
        this.warning = function (msg) {
            if (_this.logger) {
                _this.logger.warn(msg);
            }
        };
        this.info = function (msg) {
            if (_this.logger) {
                _this.logger.info('INFO: ' + msg);
            }
        };
    }
    return InternalLogger;
}());
exports.InternalLogger = InternalLogger;
exports.logger = new InternalLogger();
